import type { CardProps } from "@karrtopelka/cards/types";
import { limboProvocation } from "@karrtopelka/cards/provocations";

/** Win card: the CALLED target — the brag is the nerve, the roll goes in the caption. */
export function buildLimboCard(
  target: number,
  value: number,
  handle: string,
  submit: { total: number; percentile: number } | null,
): CardProps {
  const props: CardProps = {
    game: "limbo",
    display: `${target.toFixed(2)}x`,
    handle,
    provocation: limboProvocation(value),
    date: new Date().toISOString().slice(0, 10),
  };
  if (submit && submit.total >= 10) {
    props.rankLine = `top ${submit.percentile}% today`;
  }
  return props;
}
